// スムーススクロール機能
document.addEventListener('DOMContentLoaded', function() {
  const pageLinks = document.querySelectorAll('ul.mod-pagelink a[href^="#"]');
  
  pageLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        
        setTimeout(function() {
          history.pushState(null, null, '#' + targetId);
        }, 100);
      }
    });
  });
  
  if (window.location.hash) {
    setTimeout(function() {
      const targetElement = document.querySelector(window.location.hash);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }
});
